import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
}

interface UpdateInstallationOrderParams {
  sortOrder: {
    installationId: number;
    sortOrder: number;
  }[];
}

export function useUpdateInstallationOrder({ projectId }: Params) {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (update: UpdateInstallationOrderParams) =>
      post({
        url: `/projects/${projectId}/installations/sort-order`,
        body: update.sortOrder,
      }),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: queryKeys.getInstallations(projectId),
      });
    },
  });

  const updateInstallationOrder = useCallback(
    (update: UpdateInstallationOrderParams) => mutate(update),
    [mutate]
  );

  return {
    updateInstallationOrder,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
